import React, { FC, useState } from 'react';
import classNames from 'classnames';
import { ReactComponent as ArrowSvg } from 'assets/img/arrowOpenBlock.svg';
import { ReactComponent as CalendarSvg } from 'assets/img/iconCalendar.svg';
import { ReactComponent as IconDownloadWhite } from './img/iconDownload.svg';
import { ReactComponent as IconDownload } from './img/iconDownload2.svg';
import styles from './SelectedMounth.module.scss';
import { addSpaceNumber } from 'utils/addSpaceNumber';
import ContentLoader from 'react-content-loader';
import { Button } from 'ui/Button';
import { Modal } from 'components/Modal';
import { Title } from 'components/Title';
import { DatePicker } from '@mantine/dates';
import { Loader } from '@mantine/core';
import { getAuthorizationHeader } from 'redux/Api/employedsApi/employedsApi';
import moment from 'moment';
import { useMediaQuery } from '@mantine/hooks';

interface SelectedMounthTypes {
  listMounth: any;
  selectedMonth: any;
  total_amount?: number;
  setSelectedMonth: (e: string) => void;
  selectedYear: number;
  setSelectedYear: (year: number) => void;
  showTotal_amount: boolean;
  loading?: boolean;
  setPage?: (page: number) => void;
  setErrorDownloadReport?: (error: string) => void;
}

export const NewSelectedMounth: FC<SelectedMounthTypes> = ({
  setSelectedMonth,
  selectedMonth,
  listMounth,
  total_amount,
  selectedYear,
  setSelectedYear,
  showTotal_amount,
  loading = false,
  setPage,
  setErrorDownloadReport,
}) => {
  const [show, setShow] = useState(false);
  const [showDownloadModalSummary, setShowDownloadModalSummary] = useState(false);
  const isMobile = useMediaQuery('(max-width: 768px)');

  const prevHandler = () => {
    setPage?.(1);
    if (listMounth.length > 0 && selectedMonth) {
      if (selectedMonth.key === 1) {
        setSelectedYear(selectedYear - 1);
        const decemberMonth = listMounth.find((elem: any) => elem.key === 12);
        setSelectedMonth(decemberMonth.name);
      } else {
        const currentMonth = listMounth.find(
          (elem: any) => elem.key === selectedMonth.key - 1,
        );
        setSelectedMonth(currentMonth.name);
      }
    }
  };

  const nextHandler = () => {
    setPage?.(1);
    if (listMounth.length > 0 && selectedMonth) {
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1;
      const currentYear = currentDate.getFullYear();

      if (
        selectedYear < currentYear ||
        (selectedYear === currentYear && selectedMonth.key < currentMonth)
      ) {
        if (selectedMonth.key === 12) {
          setSelectedYear(selectedYear + 1);
          const januaryMonth = listMounth.find((elem: any) => elem.key === 1);
          setSelectedMonth(januaryMonth.name);
        } else {
          const nextMonth = listMounth.find(
            (elem: any) => elem.key === selectedMonth.key + 1,
          );
          setSelectedMonth(nextMonth.name);
        }
      }
    }
  };

  return (
    <>
      <div className={classNames(styles.root)}>
        <div className={styles.progressBlockHeader}>
          <div
            onClick={() => setShow(!show)}
            className={classNames(
              styles.root_titleBlock,
              show && styles.root_titleBlock_rotateSvg,
            )}>
            <div onClick={prevHandler} className={styles.leftArrow}>
              <ArrowSvg width={12} height={16} />
            </div>
            <div className={styles.root_title}>
              <CalendarSvg />
              <p>
                {selectedMonth.name}{' '}
                {selectedYear !== new Date().getFullYear() && selectedYear}
              </p>
            </div>
            <div onClick={nextHandler} className={styles.rightArrow}>
              <ArrowSvg width={12} height={16} />
            </div>
          </div>
          <Button
            theme='outline'
            className={styles.progressBlockHeader_downloadBtn}
            onClick={() => {
              setShowDownloadModalSummary(true);
            }}>
            <div className={styles.progressBlockHeader_download}>
              {!isMobile && 'Отчет за период'}
              <IconDownload style={{ width: '20px', height: '20px' }} />
            </div>
          </Button>
        </div>
        {showTotal_amount ? (
          loading ? (
            <p className={classNames(styles.root_price, styles.price)}>
              <span className={styles.price_placeholder}>
                {total_amount ? addSpaceNumber(total_amount) : 0} ₽
              </span>
              <ContentLoader
                speed={2}
                height={18}
                className={styles.price_skeleton}
                backgroundColor={'#FFFFFF'}
                foregroundColor={'#D8E4FB8C'}>
                <rect x='0' y='0' rx='0' ry='0' width='100%' height='100%' />
              </ContentLoader>
            </p>
          ) : (
            <p className={styles.root_price}>
              {total_amount ? addSpaceNumber(total_amount) : 0} ₽
            </p>
          )
        ) : null}
      </div>
      {showDownloadModalSummary && (
        <DownloadModalSummary
          setErrorDownloadReport={setErrorDownloadReport}
          showDownloadModalSummary={showDownloadModalSummary}
          setShowDownloadModalSummary={setShowDownloadModalSummary}
          selectedMonth={selectedMonth}
          selectedYear={selectedYear}
        />
      )}
    </>
  );
};

interface DownloadModalSummaryTypes {
  showDownloadModalSummary: boolean;
  setShowDownloadModalSummary: (show: boolean) => void;
  setErrorDownloadReport?: (error: string) => void;
  selectedMonth: { name: string; key: number };
  selectedYear: number;
}

export const DownloadModalSummary: FC<DownloadModalSummaryTypes> = ({
  showDownloadModalSummary,
  setShowDownloadModalSummary,
  setErrorDownloadReport,
  selectedMonth,
  selectedYear,
}) => {
  const [value, setValue] = useState<[Date | null, Date | null]>([null, null]);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const monthStart = new Date(selectedYear, selectedMonth.key - 1, 1);
  const now = new Date();
  const isCurrentMonth =
    selectedYear === now.getFullYear() && selectedMonth.key === now.getMonth() + 1;
  const monthEnd = isCurrentMonth
    ? new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1)
    : new Date(selectedYear, selectedMonth.key, 0);

  const handleDownload = async () => {
    const date_start = value[0] ? moment(value[0]).format('YYYY-MM-DD') : null;
    let date_end = value[1] ? moment(value[1]).format('YYYY-MM-DD') : null;

    if (!date_start) {
      setError('Выбери дату');
      return;
    }

    if (!date_end) {
      date_end = date_start;
    }

    setError(null);
    setIsLoading(true);
    try {
      const responseFile = await fetch(
        `${process.env.REACT_APP_API_URL}/api/orders/docs/interval-report`,
        {
          method: 'POST',
          body: JSON.stringify({ date_start, date_end }),
          headers: {
            Authorization: getAuthorizationHeader(),
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        },
      );

      const fileData = await responseFile.json().catch(() => null);

      if (!responseFile.ok) {
        setErrorDownloadReport?.(
          fileData?.message ||
            fileData?.errors?.date_start?.[0] ||
            fileData?.errors?.date_end?.[0] ||
            'Произошла ошибка при скачивании отчета',
        );
        return;
      }

      const { file_id } = fileData;

      const responseToken = await fetch(
        `${process.env.REACT_APP_API_URL}/api/customer/docs/download/one-time-token`,
        {
          method: 'GET',
          headers: {
            Authorization: getAuthorizationHeader(),
            Accept: 'application/json',
          },
        },
      );

      const tokenData = await responseToken.json().catch(() => null);

      if (!responseToken.ok) {
        setErrorDownloadReport?.(
          tokenData?.message || 'Произошла ошибка при скачивании отчета',
        );
        return;
      }

      const { token } = tokenData;
      const url = `${process.env.REACT_APP_API_URL}/api/customer/docs/interval-report/${file_id}/download/${token}`;
      window.open(url, '_self');
      setShowDownloadModalSummary(false);
    } catch (error) {
      setErrorDownloadReport?.('Произошла ошибка при скачивании отчета');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal open={showDownloadModalSummary} setOpen={setShowDownloadModalSummary}>
      <div className={styles.rootModalSummary}>
        <Title title={'Отчет за период'} />
        <div className={styles.datePickerContainer}>
          <DatePicker
            type='range'
            value={value}
            onChange={setValue}
            allowSingleDateInRange
            defaultDate={monthStart}
            minDate={monthStart}
            maxDate={monthEnd}
            maxLevel='month'
            classNames={{
              calendarHeaderControl: styles.hideMonthControl,
              calendarHeaderLevel: styles.hideMonthLevelHover,
            }}
            styles={{
              calendarHeaderControl: { display: 'none' },
            }}
          />
        </div>
        <Button theme='filed' size='L' onClick={isLoading ? undefined : handleDownload}>
          <div className={styles.progressBlockHeader_download}>
            Скачать отчет
            {isLoading ? <Loader size='xs' color='white' /> : <IconDownloadWhite />}
          </div>
        </Button>
        {error && <p className={styles.error}>{error}</p>}
      </div>
    </Modal>
  );
};
